const validatePermission = (permissions, module, capability) => {
    return permissions
        ?.filter((item) => item?.name === module)
        ?.find((item) => item?.capability === capability)
}
export { validatePermission }
